define([
	"dojo/_base/declare",
	"Apparel/StructureItemTable",
	"SiteAdmin/RevisionHeadingsController"
], function(declare,StructureItemTable,RevisionHeadingsController) {

	return declare([StructureItemTable, RevisionHeadingsController], {
	});
});